"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _jsTools = require("@airportlabs/js-tools");
var _authType = require("./authType");
var _tokens = require("./tokens");
var ACCESS_TOKEN_PARAM = undefined;
var REFRESH_TOKEN_PARAM = undefined;
var AUTH_TYPE = (0, _authType.getAuthType)();
var LOGOUT_URL = (0, _jsTools.getEnv)("REACT_APP_LOGOUT_URL");
var redirectToLogout = function redirectToLogout(_ref) {
  var _ref$withBack = _ref.withBack,
    withBack = _ref$withBack === void 0 ? false : _ref$withBack;
  (0, _tokens.clearTokens)();
  var href = withBack ? (0, _jsTools.appendParamsToUrl)(LOGOUT_URL, {
    back: (0, _jsTools.omitParamsFromUrl)(window.location.href, REFRESH_TOKEN_PARAM, ACCESS_TOKEN_PARAM),
    isRequired: AUTH_TYPE !== _authType.authTypes.NONE
  }) : LOGOUT_URL;
  _jsTools.authConsole.log("redirectToLogout", href);
  window.location = href;
};
var _default = exports["default"] = redirectToLogout;